const modalTheme = {
  content: {}
};
const defaultTheme = {
  modalTheme
};

export { defaultTheme };
//# sourceMappingURL=defaults.js.map
